export default __webpack_public_path__ + "src/assets/images/powerstrip/powerstrip_US.png?71ccf72a";